interface IGetGooglePlace {
  id: string
}

export const getGooglePlace = async (req: IGetGooglePlace) => {
  const endpoint =
    "https://us-central1-polysleep-5290e.cloudfunctions.net/getPlaceInfoWithID";
  try {
    const res = await fetch(endpoint, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(req),
    })
    const response = await res.json()
    return response?.placeInfo?.result;
  } catch (e) {
    console.error(`getGooglePlace error ${e.message}`, e)
  }
};